export const ActionName = {
  GET_CATEGORIES_PENDING: "GET_CATEGORIES_PENDING",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILED: "GET_CATEGORIES_FAILED",
  GET_SUB_CATEGORIES_PENDING: "GET_SUB_CATEGORIES_PENDING",
  GET_SUB_CATEGORIES_SUCCESS: "GET_SUB_CATEGORIES_SUCCESS",
  GET_SUB_CATEGORIES_FAILED: "GET_SUB_CATEGORIES_FAILED",
  GET_PRODUCTS_PENDING: "GET_PRODUCTS_PENDING",
  GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAILED: "GET_PRODUCTS_FAILED",
  GET_CART_ITEMS_PENDING: "GET_CART_ITEMS_PENDING",
  GET_CART_ITEMS_SUCCESS: "GET_CART_ITEMS_SUCCESS",
  GET_CART_ITEMS_FAILED: "GET_CART_ITEMS_FAILED",
  ADD_CART_ITEMS_PENDING: "ADD_CART_ITEMS_PENDING",
  ADD_CART_ITEMS_SUCCESS: "ADD_CART_ITEMS_SUCCESS",
  ADD_CART_ITEMS_FAILED: "ADD_CART_ITEMS_FAILED",
  INCREMENT_CART_ITEMS_PENDING: "INCREMENT_CART_ITEMS_PENDING",
  INCREMENT_CART_ITEMS_SUCCESS: "INCREMENT_CART_ITEMS_SUCCESS",
  INCREMENT_CART_ITEMS_FAILED: "INCREMENT_CART_ITEMS_FAILED",
  DECREMENT_CART_ITEMS_PENDING: "DECREMENT_CART_ITEMS_PENDING",
  DECREMENT_CART_ITEMS_SUCCESS: "DECREMENT_CART_ITEMS_SUCCESS",
  DECREMENT_CART_ITEMS_FAILED: "DECREMENT_CART_ITEMS_FAILED",
  REMOVE_CART_ITEMS_PENDING: "REMOVE_CART_ITEMS_PENDING",
  REMOVE_CART_ITEMS_SUCCESS: "REMOVE_CART_ITEMS_SUCCESS",
  REMOVE_CART_ITEMS_FAILED: "REMOVE_CART_ITEMS_FAILED",
  GET_CART_TOTAL_ITEMS_PENDING: "GET_CART_TOTAL_ITEMS_PENDING",
  GET_CART_TOTAL_ITEMS_SUCCESS: "GET_CART_TOTAL_ITEMS_SUCCESS",
  GET_CART_TOTAL_ITEMS_FAILED: "GET_CART_TOTAL_ITEMS_FAILED",
  GET_SEARCH_ITEMS_PENDING: "GET_SEARCH_ITEMS_PENDING",
  GET_SEARCH_ITEMS_SUCCESS: "GET_SEARCH_ITEMS_SUCCESS",
  GET_SEARCH_ITEMS_FAILED: "GET_SEARCH_ITEMS_FAILED",
  GET_CART_TOTAL_AMOUNT_PENDING: "GET_CART_TOTAL_AMOUNT_PENDING",
  GET_CART_TOTAL_AMOUNT_SUCCESS: "GET_CART_TOTAL_AMOUNT_SUCCESS",
  GET_CART_TOTAL_AMOUNT_FAILED: "GET_CART_TOTAL_AMOUNT_FAILED",
  ADD_CONTACT_PENDING: "ADD_CONTACT_PENDING",
  ADD_CONTACT_SUCCESS: " ADD_CONTACT_SUCCESS",
  ADD_CONTACT_FAILED: "ADD_CONTACT_FAILED",
  GET_USER_BY_EMAIL_PENDING: "GET_USER_BY_EMAIL_PENDING",
  GET_USER_BY_EMAIL_SUCCESS: "GET_USER_BY_EMAIL_SUCCESS",
  GET_USER_BY_EMAIL_FAILED: "GET_USER_BY_EMAIL_FAILED",
};

export const BaseURL = "https://essencebackend.onrender.com";
